import { countryCode } from '../../models/countryCode.model';

export const CountryCodeConst: countryCode = {
  areaCodes: undefined,
  dialCode: '1',
  flagClass: 'US',
  iso2: 'us',
  name: 'United States',
  placeHolder: '+12015550123',
  priority: 0
};
